import { useQuery } from 'react-query';
import { getShopperEvents } from './heroApiClient';

export const useGetShopperEvents = (shopperId?: string) =>
  useQuery(
    ['getShopperEvents', shopperId],
    async () => {
      if (!shopperId) {
        return;
      }
      return getShopperEvents(shopperId);
    },
    {
      staleTime: Infinity,
      enabled: Boolean(shopperId),
    }
  );
